import { useState } from 'react';
var setCookie = function (name, value, options) {
    if (typeof document !== 'undefined') {
        var expires = options.days
            ? new Date(Date.now() + options.days * 864e5).toUTCString()
            : '';
        document.cookie =
            name +
                '=' +
                encodeURIComponent(value) +
                '; expires=' +
                expires +
                '; path=' +
                options.path;
    }
};
var getCookie = function (name) {
    if (typeof document === 'undefined') {
        return '';
    }
    return document.cookie.split('; ').reduce(function (r, v) {
        var parts = v.split('=');
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, '');
};
export var useCookie = function (key, initialValue) {
    var _a = useState(function () {
        return getCookie(key) || initialValue;
    }), item = _a[0], setItem = _a[1];
    var updateItem = function (value, options) {
        if (options === void 0) { options = { path: '/' }; }
        setItem(value);
        setCookie(key, value, options);
    };
    return [item, updateItem];
};
